<template>
    <div class="w-1/2 h-px py-0.5 top-1/2" :class="[isCurrentStep ? 'bg-primary' : 'bg-gray-200']">
      <div
        class="rounded rounded-full h-6 w-6 flex flex-col justify-center relative mx-auto transform -translate-y-1/2" :class="[isCurrentStep ? ' bg-primary' : 'bg-gray-200']">
        <div class="text-white icon-check-mark-button text-center" />
      </div>
      <div class="text-center text-gray-500">
        <slot/>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    //step is the step number associated
    step: {
      type: Number,
      default: 0
    }
  },
  name: 'ZStepperStep',
  computed: {
    isCurrentStep () {
      return this.$parent.value === this.step
    }
  }
}
</script>

<style scoped></style>
